import script from "./ClassifierDataGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassifierDataGrid.vue?vue&type=script&setup=true&lang=js"

import "./ClassifierDataGrid.vue?vue&type=style&index=0&id=f1ffbc24&lang=css"

const __exports__ = script;

export default __exports__